import axios from 'axios'
import HTTP from './http'

export default {
    getCompany: payload => axios.get(HTTP.COMPANY, { params: payload }),
    addCompany: payload => axios.post(HTTP.COMPANY, payload),
    updateCompany: payload => axios.put(HTTP.COMPANY, payload),
    deleteCompany: payload => axios.delete(HTTP.COMPANY, { params: { id: payload } }),
    getList: () => axios.get(HTTP.COMPANIES_LIST),
    getHmoList: () => axios.get(HTTP.COMPANIES_HMO_LIST)
}
